import React from 'react'

export default function PollAnalytics() {
  return (
    <div>
      <h1>Placeholder for poll analytics</h1>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/PollAnalytics/index.js